import $ from 'jquery';
import get from 'lodash/get';

import registerJQueryPlugin, { noopActions } from '../../lib/register-jquery-plugin';
import './field-container';
import './character-counter';
import './floating-label-plugin';
import './fixed-label-plugin';
import './entry-error';
import './radio-group-validator';
import setupMirrorField from './mirror-field';

// Does the initial setup so that the mirrorField jQuery plugin is available
setupMirrorField();

const makeGetContainer = $container => ($els) => {
    if ($container && $container.length) {
        return $container.find($els);
    }

    return $els;
};

export default function formField(el, _options = {}, { deregister } = noopActions) {
    const $el = $(el);

    const $entryErrors = $el.find('[data-entry-error]:visible').entryError({
        requiredTemplate: get(window, 'rcProps.entryError.requiredTemplate', ''),
        invalidTemplate: get(window, 'rcProps.entryError.invalidTemplate', ''),
    });

    const $floatingLabels = $el.find('.floating-label:visible').floatingLabel();
    const $fixedLabels = $el.find('.fixed-label:visible').fixedLabel();
    const $fieldLabelContainers = $el
        .find(document.getElementsByClassName('fixed-label--container'))
        .fieldLabelContainer();
    const $characterCounters = $el
        .find(document.getElementsByClassName('character-counter-field'))
        .characterCounter();
    const $characterCountersInput = $el
        .find(document.getElementsByClassName('character-counter-input'))
        .characterCounter({ fieldSelector: 'input' });
    const $mirrorFields = $el
        .find(document.querySelectorAll('[data-mirror-field-name]'))
        .mirrorField();
    const $validateRadioGroups = $el
        .find(document.getElementsByClassName('validate-radio-group'))
        .radioGroupValidator({
            errorClassName: 'form-section__error',
            errorTemplate: get(window, 'rcProps.validateRadioGroup.errorTemplate'),
        });

    return {
        teardown: (teardownOptions = {}) => {
            const { $container } = teardownOptions;
            // If a container has been provided, this means that the intention is
            // to keep around some of the instances. Therefore, if we intended to
            // teardown all instances but it had previously been torn down, then
            // an error would be thrown accidentally when it wasn't the intention.
            if (!$container) {
                deregister();
            }

            const getContainer = makeGetContainer($el.find($container));

            getContainer($floatingLabels).floatingLabel('removeListeners');
            getContainer($fixedLabels).fixedLabel('removeListeners');
            getContainer($entryErrors).entryError('destroy');
            getContainer($fieldLabelContainers).fieldLabelContainer('removeListeners');
            getContainer($characterCounters).characterCounter('removeListeners');
            getContainer($characterCountersInput).characterCounter('removeListeners');
            getContainer($mirrorFields).mirrorField('destroy');
            getContainer($validateRadioGroups).radioGroupValidator('removeListeners');
        },
    };
}

registerJQueryPlugin('formField', formField);



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/form-field.js